export const REPOSITION_NAV_BAR:'REPOSITION_NAV_BAR' = 'REPOSITION_NAV_BAR';
export const ADD_NAV_BAR:'ADD_NAV_BAR' = 'ADD_NAV_BAR';
export const ADD_NAV_BAR_UID:'ADD_NAV_BAR_UID' = 'ADD_NAV_BAR_UID';
export const REMOVE_NAV_BAR:'REMOVE_NAV_BAR' = 'REMOVE_NAV_BAR';